var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[(!_vm.$vuetify.breakpoint.mobile)?_c('TopBarDesktop'):_c('TopBarMobile'),_c('MainContainer'),_c('BottomBar'),_c('Snackbar'),_c('CookiesInfo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }